import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WaitTimePredictionSettingsService {
  constructor(private restService: RestService) {}

  getSettings(): Observable<void> {
    return this.restService.request<void, void>({
      method: 'GET',
      url: '/api/app/wait-time-prediction-settings',
    });
  }

  updateSettings(body): Observable<void> {
    return this.restService.request<void, void>({
      method: 'PUT',
      url: '/api/app/wait-time-prediction-settings',
      body,
    });
  }
}
